export enum Currency {
	EUR = 0,
	GBP = 10
}
